import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileZip"><Path fillRule="evenodd" clipRule="evenodd" d="M12.5 2H4V22H8V20.5H9.5V22H20V9.5H12.5V2ZM9.5 19V20.5H11V19H9.5ZM9.5 17.5H8V19H9.5V17.5ZM9.5 16V17.5H11V16H9.5ZM9.5 14.5H8V16H9.5V14.5ZM9.5 13V14.5H11V13H9.5ZM9.5 13V11.5H8V13H9.5Z" fill="currentColor"/><Path d="M14 8V2H14.0607L20 7.93934V8H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileZip;
